var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "@/interface/IVueDialog";
import GoodService from '@/api/GoodService';
import CategoryService from '@/api/CategoryService';
import LeftTree from './LeftTree.vue';
import TabTable from './TabTable.vue';
import _ from 'lodash';
import CommonService from '@/api/CommonService';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.treeBusinessData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {
            business_goods_type_id: undefined,
        };
        _this.categoryData = [];
        _this.tableFlag = '0';
        return _this;
    }
    AddGoods.prototype.normalizerGoodType = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children && node.children.length ? node.children : undefined,
        };
    };
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        this.service = GoodService.getInstance();
        this.categoryService = CategoryService.getInstance();
        this.commonService = CommonService.getInstance();
        console.log(999, this.addedDatas);
        this.tableFlag = this.initTableFlag || this.tableFlag;
        if (this.addedDatas) {
            this.selectedList = _.cloneDeep(this.addedDatas ? this.addedDatas : []);
        }
        this.getCategory();
    };
    AddGoods.prototype.mounted = function () {
        console.log('mounted', this.tableFlag);
        this.$refs.leftTree.tableFlag = this.tableFlag;
        this.$refs.grid.isShowBusiness = this.tableFlag;
        this.$refs.alreadyGrid.isShowBusiness = this.tableFlag;
        console.log('this.$refs.leftTree.tableFlag', this.$refs.leftTree.tableFlag);
    };
    AddGoods.prototype.getCategory = function () {
        var _this = this;
        console.log('getCategory');
        var _a = [[], [], []], supplier_to_business_id = _a[0], delivery_order_ids = _a[1];
        this.selectedOrders.forEach(function (item) {
            supplier_to_business_id.push(item.supplier_to_business_id);
            delivery_order_ids.push(item.delivery_order_id);
        });
        var params = {
            supplier_to_business_ids: Array.from(new Set(supplier_to_business_id)).join(','),
            business_scm_id: this.curGoodNode && this.curGoodNode.business_scm_id,
            delivery_order_ids: delivery_order_ids.join(','),
            is_all: 1
        };
        var func = this.type == 'entrust' ? 'getEntrustDeliverCategory' : 'getDeliverCategory';
        this.categoryService[func](params).then(function (res) {
            console.log('getCategory result>>>', res);
            var DATA = res.data || {};
            _this.categoryData = Array.isArray(DATA.data) ? DATA.data : [];
        }, function (err) {
            console.log('err>>>', err);
        });
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.tableFlag = this.$refs.leftTree.tableFlag;
        var params = {
            keyword: this.formData.keyword,
            business_goods_type_id: this.formData.business_goods_type_id
        };
        if (this.curGoodNode && (this.curGoodNode.value || this.curGoodNode.goods_type_id != '-1')) {
            params = Object.assign({}, params, {
                delivery_order_ids: this.curGoodNode.delivery_order_ids,
                goods_type_id: this.curGoodNode.goods_type_id,
                business_ids: this.curGoodNode.business_id || 0,
                supplier_to_business_ids: this.curGoodNode.supplier_to_business_id || 0,
                group_id: this.curGoodNode.group_id || 0,
            });
        }
        var goods_ids;
        var filter = function (item) {
            return !item.hideInUnselect;
        };
        goods_ids = (this.selectedList || []).filter(filter).map(function (item) {
            return item.goods_id;
        });
        console.log(1212, params, this.$refs.leftTree);
        if (this.tableFlag - 0 === 0) {
            this.service.getBusinessGoodList(Object.assign({}, params, {
                notin_goods_ids: [],
                delivery_order_ids: String(this.orderIds),
            }, pager)).then(function (res) {
                if (res.data.success) {
                    if (res.data.data.length == 0 && pager.page > 1) {
                        _this.search();
                        return;
                    }
                    _this.tableData = res.data.data;
                    _this.unSelectList = res.data.data;
                    _this.total = res.data.total;
                    _this.setSelected(true);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            this.service.getGoodList(Object.assign({}, params, {
                status: -1,
                delivery_order_ids: String(this.orderIds),
                notin_goods_ids: goods_ids
            }, pager)).then(function (res) {
                if (res.data.success) {
                    if (res.data.data.length == 0 && pager.page > 1) {
                        _this.search();
                        return;
                    }
                    console.log(res.data.data);
                    _this.tableData = res.data.data;
                    _this.unSelectList = res.data.data;
                    _this.total = res.data.count;
                    _this.setSelected(true);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    AddGoods.prototype.changeShowBusiness = function (val) {
        this.tableFlag = val;
        console.log('changeShowBusiness', this.tableFlag);
        this.$refs.grid.isShowBusiness = this.tableFlag;
        this.$refs.alreadyGrid.isShowBusiness = this.tableFlag;
        this.selectedList = [];
        this.setSelected(true);
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        console.log('selectChange rows>>>', rows);
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'goods_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.goods_id === currentRow.goods_id; })) {
            _.remove(this.selectedList, function (good) { return good.goods_id === currentRow.goods_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.goods_id === good.goods_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
        });
    };
    AddGoods.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs && this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.$emit('previewDate', this.selectedList);
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_id === good.goods_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
        this.updateUnSelectedListChild();
    };
    AddGoods.prototype.updateUnSelectedListChild = function () {
        var _a = this, selectedList = _a.selectedList, unSelectList = _a.unSelectList;
        if (selectedList.length) {
            unSelectList.forEach(function (item) {
                var index = selectedList.findIndex(function (s) { return s.goods_id === item.goods_id; });
                if (index > -1) {
                    item.selected_deliver_order = selectedList[index].selected_deliver_order || [];
                }
            });
        }
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'goods_id');
        this.$closeDialog();
        var tableFlag = this.tableFlag;
        this.$emit('save:ok', data, tableFlag);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.getCategory();
        this.gitRightList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        if (this.$refs.grid.$refs && this.$refs.grid.$refs.table) {
            this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
        }
    };
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], AddGoods.prototype, "addedDatas", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], AddGoods.prototype, "orderIds", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], AddGoods.prototype, "type", void 0);
    __decorate([
        Prop({
            default: '0'
        })
    ], AddGoods.prototype, "initTableFlag", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], AddGoods.prototype, "selectedOrders", void 0);
    AddGoods = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
